import { FC } from 'react'

interface IProps {
  operationNumber: string
  onAccept: () => void
}

export const PaymentCodeModal: FC<IProps> = ({ operationNumber, onAccept }) => (
  <div
    className='position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center'
    style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
  >
    <div className='card p-8 position-relative' style={{ maxWidth: 420 }}>
      <button
        type='button'
        className='btn-close position-absolute top-0 end-0 m-4'
        aria-label='Cerrar'
        onClick={onAccept}
      ></button>
      <div
        className='d-flex align-items-center justify-content-center mx-auto mb-4'
        style={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 123, 195, 0.1)',
        }}
      >
        <i className='bi bi-exclamation-triangle text-primary' style={{ fontSize: '1.5rem' }}></i>
      </div>
      <h3 className='text-center mb-4'>Código para efectuar el pago:</h3>
      <div className='text-center mb-4'>
        <span className='fs-1 fw-bolder'>{operationNumber}</span>
      </div>
      <p className='text-center text-muted mb-6'>
        Solicita al usuario que efectúe el pago de la inversión en su banco con el código
        proporcionado. Tendrá un plazo máximo de 72 horas para realizarlo.
      </p>
      <button type='button' className='btn btn-solid-primary w-100' onClick={onAccept}>
        Aceptar
      </button>
    </div>
  </div>
)
